import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import State from "../State";

const SuccessModal = ({
  id = "success-modal",
  title,
  description,
  buttonLabel,
  onButtonClick,
  isOpened,
  onClose,
  maxWidth = "500",
}) => {
  const { t } = useTranslation("common");

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const bootstrapModal = window.bootstrap?.Modal?.getOrCreateInstance(el);
    if (!bootstrapModal) return;
    if (isOpened) {
      bootstrapModal.show();
    } else {
      bootstrapModal.hide();
    }
  }, [isOpened, id]);

  return (
    <Modal
      id={id}
      maxWidth={maxWidth}
      isOpened={isOpened}
      onClose={onClose}
      hasCloseBtn={true}
    >
      <State
        type="success"
        title={title || t("success", "Success!")}
        desc={description}
        titleFontSize={24}
        descFontSize={16}
        hasIconStroke={true}
      >
        <div className="d-grid gap-2 mt-4">
          <button
            type="button"
            className="btn btn-main-color"
            data-bs-dismiss="modal"
            onClick={() => {
              onButtonClick?.();
            }}
          >
            {buttonLabel || t("done", "Done")}
          </button>
        </div>
      </State>
    </Modal>
  );
};

SuccessModal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  onButtonClick: PropTypes.func,
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  maxWidth: PropTypes.string,
};

export default SuccessModal;
